import axios from 'utils/axios';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  error: false,
  data: [],
  /** Which application `data` was last successfully loaded for (render guard). */
  dataAppId: null,
  /** In-flight overview request appId; drop stale HTTP responses. */
  requestAppId: null,
};

const slice = createSlice({
  name: 'revenueManagementOverview',
  initialState,
  reducers: {
    prepareFetch(state, action) {
      const id = Number(action.payload);
      state.isLoading = true;
      state.error = false;
      state.requestAppId = id;
      if (state.dataAppId !== id) {
        state.data = [];
        state.dataAppId = null;
      }
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getRevenueManagementOverviewSuccess(state, action) {
      const { data, appId } = action.payload;
      if (Number(appId) !== state.requestAppId) {
        return;
      }
      state.isLoading = false;
      state.data = data;
      state.dataAppId = appId;
    },
  },
});

export default slice.reducer;

export function getRevenueManagementOverview(appId, { startDate, endDate }) {
  return async (dispatch) => {
    const id = Number(appId);
    dispatch(slice.actions.prepareFetch(id));
    try {
      const response = await axios.get(
        `/revenue-management/${appId}/overview?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`,
      );
      dispatch(slice.actions.getRevenueManagementOverviewSuccess({ data: response, appId: id }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
